import type { TMessages } from '@/types/TMessages'

export const messages = {
  noAccountsErrorModal: {
    title: 'Доступные расчётные счета для формирования документа не найдены',
    close: 'Закрыть',
  },
  orderActions: {
    getAccreditation: {
      button: 'Заполнить вручную',
    },
    getAccreditationWithUKEP: {
      button: 'Заполнить и подписать с УКЭП',
    },
    selectTypeSign: {
      button: 'Согласиться и выбрать подпись',
    },
  },
  requestActions: {
    getAccreditation: {
      button: 'Перейти к загрузке документов',
    },
  },
  organizationDetailsRequired: {
    title: 'Не заполнены данные организации',
    description:
      'Часть данных организации не заполнена. Поэтому подписать оферту не удалось. Добавить недостающие данные можно через службу поддержки.',
    toFeedback: 'Написать в поддержку',
  },
  downloadCheck: 'Счет на оплату.pdf',
  warningModal: {
    title: 'Заполните недостающие данные',
    messageTitle: 'Для подтверждения предложения добавьте в профиль организации следующую информацию:',
    buttonTitle: 'Заполнить',
  },
} satisfies TMessages
